/**
 * ClarityMD cart drawer.
 *
 * Chan submit cua moi form /cart/add roi tu goi Ajax Cart API, sau do mo drawer.
 * Ruot drawer duoc lay lai bang Section Rendering API (?section_id=cmd-cart-drawer)
 * nen moi thu tinh trong Liquid (tien do free ship, upsell, tong tien) luon dung.
 */
(function () {
  'use strict';

  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  var drawer, panel, content, loading, errorBox, lastFocus, noteTimer, scrollY = 0;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    drawer = document.getElementById('cmd-cart-drawer');
    if (!drawer) return;

    panel = drawer.querySelector('.cmd-cd__panel');
    content = document.getElementById('cmd-cd-content');
    loading = drawer.querySelector('[data-cmd-cd-loading]');
    errorBox = drawer.querySelector('[data-cmd-cd-error]');

    bindClose();
    bindTriggers();
    bindForms();
    bindBody();
  }

  /* ---------------------------------------------------------------- *
   * Mo / dong
   * ---------------------------------------------------------------- */
  function open() {
    lastFocus = document.activeElement;
    scrollY = window.scrollY || window.pageYOffset;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cmd-cd-lock');
    document.body.style.top = '-' + scrollY + 'px';

    var btn = panel.querySelector('.cmd-cd__close');
    if (btn) btn.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cmd-cd-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function bindClose() {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cmd-cd-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trap(e);
    });
  }

  // Giu focus ben trong drawer khi dang mo.
  function trap(e) {
    var items = panel.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, [tabindex]:not([tabindex="-1"])'
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------------------------------------------------------------- *
   * Icon gio hang tren header -> mo drawer cua minh
   * ---------------------------------------------------------------- */
  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest(
        '[data-testid="cart-drawer-trigger"], a[href$="/cart"], a[href*="/cart?"], [data-cmd-cd-open]'
      );
      if (!el) return;

      // Link "View cart" nam BEN TRONG drawer -> de no di toi /cart that,
      // khong bat lai thanh mo drawer (se thanh bam mai khong di dau duoc).
      if (drawer.contains(el)) return;

      e.preventDefault();
      e.stopPropagation();
      refresh(open);
    }, true);
  }

  /* ---------------------------------------------------------------- *
   * Goi API
   * ---------------------------------------------------------------- */
  function busy(on) {
    if (loading) loading.classList.toggle('is-on', !!on);
    if (panel) panel.classList.toggle('is-busy', !!on);
  }

  function notify(msg) {
    if (!errorBox) return;
    errorBox.textContent = msg;
    errorBox.classList.add('is-on');
    setTimeout(function () { errorBox.classList.remove('is-on'); }, 4000);
  }

  // Tai lai ruot drawer qua Section Rendering API.
  function refresh(done) {
    busy(true);
    fetch(ROOT + '?section_id=cmd-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        busy(false);
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cmd-cd-content');
        if (fresh && content && content.parentNode) {
          content.parentNode.replaceChild(fresh, content);
          content = fresh;
          setCount(parseInt(content.getAttribute('data-cart-count'), 10) || 0);
        }
        if (done) done();
      })
      .catch(function () {
        busy(false);
        notify('Could not refresh your cart. Please try again.');
        if (done) done();
      });
  }

  function post(url, payload, done) {
    busy(true);
    fetch(ROOT + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        busy(false);
        if (!res.ok) {
          notify((res.data && (res.data.description || res.data.message)) || 'Something went wrong');
          return;
        }
        refresh(done);
      })
      .catch(function () {
        busy(false);
        notify('Network error. Please try again.');
      });
  }

  // Dong bo so dem tren icon gio o header + tren tieu de drawer.
  function setCount(n) {
    var badge = drawer.querySelector('[data-cmd-cd-count]');
    if (badge) badge.textContent = n;

    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', n === 0);
      var txt = bubble.querySelector('.cart-bubble__text-count');
      if (txt) {
        txt.textContent = n > 99 ? '' : n;
        txt.classList.toggle('hidden', n === 0);
      }
    });
  }

  /* ---------------------------------------------------------------- *
   * Chan submit form them vao gio
   * ---------------------------------------------------------------- */
  function bindForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;

      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]:focus')
        || document.activeElement;
      if (!btn || !form.contains(btn)) {
        btn = form.querySelector('button[type="submit"]');
      }

      var data = new FormData(form);

      // Nut submit mang name="id" nen gia tri chi vao FormData khi
      // chinh no kich hoat submit. Them tay cho chac.
      if (btn && btn.name === 'id' && btn.value) {
        data.set('id', btn.value);
      }
      if (!data.get('id')) {
        form.submit();
        return;
      }
      if (!data.get('quantity')) data.set('quantity', '1');

      // `selling_plan` rong = mua le. Shopify chap nhan chuoi rong (da thu:
      // HTTP 200, selling_plan_allocation = null) nhung bo han field di thi
      // sach hon va tranh moi rui ro doi hanh vi ve sau.
      if (!data.get('selling_plan')) data.delete('selling_plan');

      if (btn) btn.classList.add('is-loading');

      busy(true);
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, data: j }; });
        })
        .then(function (res) {
          busy(false);
          if (btn) btn.classList.remove('is-loading');

          if (!res.ok) {
            notify((res.data && (res.data.description || res.data.message))
              || 'This item could not be added.');
            return;
          }
          refresh(open);
        })
        .catch(function () {
          busy(false);
          if (btn) btn.classList.remove('is-loading');
          notify('Network error. Please try again.');
        });
    });
  }

  /* ---------------------------------------------------------------- *
   * Thao tac ben trong drawer
   * ---------------------------------------------------------------- */
  function bindBody() {
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cmd-cd-qty]');
      if (qtyBtn) {
        var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);

        if (qty === 0) {
          var item = qtyBtn.closest('.cmd-cd__item');
          if (item) item.classList.add('is-going');
        }
        post('cart/change.js', { line: line, quantity: Math.max(qty, 0) });
        return;
      }

      // Nang cap goi: xoa dong cu, them variant moi.
      var swap = e.target.closest('[data-cmd-cd-swap]');
      if (swap) {
        var oldLine = parseInt(swap.getAttribute('data-line'), 10);
        var newId = swap.getAttribute('data-id');
        busy(true);
        fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: oldLine, quantity: 0 })
        })
          .then(function () {
            return fetch(ROOT + 'cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(newId), quantity: 1 }] })
            });
          })
          .then(function () { busy(false); refresh(); })
          .catch(function () {
            busy(false);
            notify('Could not upgrade your bundle. Please try again.');
          });
      }
    });

    // Luu ghi chu sau khi ngung go 700ms.
    drawer.addEventListener('input', function (e) {
      var note = e.target.closest('[data-cmd-cd-note]');
      if (!note) return;

      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).then(function () {
          var flag = drawer.querySelector('[data-cmd-cd-note-saved]');
          if (!flag) return;
          flag.classList.add('is-on');
          setTimeout(function () { flag.classList.remove('is-on'); }, 1800);
        });
      }, 700);
    });
  }
})();
